import { OptionDescriptionModalTranslation, RequestQuoteContentTranslation, SiteTranslation } from './SiteTranslation';

// tslint:disable:max-line-length

const requestQuoteTranslation: RequestQuoteContentTranslation = {
  confirmation: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Bekræftelsesside',
    buttonLink: 'Shop videre',
    title: 'Tak! Det ønskede tilbud er på vej.',
    content: 'Vores lokale forhandler vil kontakt dig snarest.',
  },
  goBackLink: 'Tilbage',
  title: 'Anmod om et tilbud',
  stepsTitle: 'Hvad sker der med min anmodning?',
  steps: [
    'Din anmodning sendes til Flokk sales',
    'Vores lokale sales udarbejder et tilbud til dig',
    'Vores lokale sales vil kontakte dig',
  ],
};

const requestQuoteServedByDealerTranslation: RequestQuoteContentTranslation = {
  ...requestQuoteTranslation,
  confirmation: {
    ...requestQuoteTranslation.confirmation,
    content: 'Vores lokale forhandler vil kontakt dig snarest.',
  },
  steps: [
    'Din anmodning sendes til Flokk sales',
    'Vores lokale sales udarbejder et tilbud til dig',
    'Vores lokale sales vil kontakte dig',
  ],
};

const optionDescriptionModal: OptionDescriptionModalTranslation = {
  closeButton:
    'Luk',
};

const translation: SiteTranslation = {
  layout: {
    topBar: {
      title: 'Flokk',
      chooseChairLink: 'Vælg stole',
      aboutUsLink: 'Om os',
      inputSearchPlaceholder: '*Search',
      languages: {
        chDe: 'Tysk',
        chFr: 'Fransk',
        deDe: 'Tysk',
        dkDk: 'Dansk',
        enUs: 'Amerikansk engelsk',
        frFr: 'Fransk',
        nlNl: 'Hollandsk',
        nbNo: 'Norsk',
        enGB: 'Engelsk',
        svSe: 'Svensk',
        plPl: 'Polsk',
      },
    },
    footerPanel: {
      emailLabel: 'e-mail: ',
      phoneLabel: 'tlf.: ',
      countactUsLink: 'Kontakt dit lokale kontor',
      followUsLabel: 'Følg os',
      copyright: 'Copyright',
      allRightReserved: 'Alle rettigheder forbeholdes',
    },
    titleFormat: '{title} - Flokk - Konfigurer din stol',
  },
  requestQuotePage: {
    errorMessage: 'Error occurred during loading hubspot form. Please contact support.',
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Anmod om tilbud',
    defaultContent: requestQuoteTranslation,
    contentWhenProcessedByDealer: requestQuoteServedByDealerTranslation,
  },
  emailMyConfigurationPage: {
    errorMessage: 'Error occurred during loading hubspot form. Please contact support.',
    pageDescriptionFormat: 'Description',
    pageTitleFormat: 'Send my configuration by email',
    confirmation: {
      pageDescriptionFormat: 'Description',
      pageTitleFormat: 'Send my configuration by email',
      buttonLink: 'Go back to home page',
      title: 'Thanks! Your mail is on the way',
      content: 'Check your inbox.',
    },
    goBackLink: 'Go back to summary',
    title: 'Send my configuration by email',
  },
  homePage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Startside',
    articleList: {
      readMore: 'Læs mere',
    },
    productList: {
      fromPriceLabel: '*From {price} inc VAT',
      productThumbnail: {
        productVariationList: {
          title: '*Variations'
        }
      }
    },
  },
  configurationSearchPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: '*Search for configuration',
    title: 'Indtast din konfigurationskode',
    description: 'og så sender vi dig videre til konfiguratoren',
    codeInputPlaceholder: 'Indtast kode her, og tryk på Enter',
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Værdien skal bestå af nøjagtigt {expectedLength} tegn.',
      codeInvalid: 'Den oplyste kode {invalidCode} er ugyldig! Sørg for, at den er angivet korrekt.',
      codeNotFound: 'Produktkonfigurationen kan ikke findes med koden {notFoundCode}',
    },
  },
  configurationDetailsPage: {
    pageTitleFormat: '*{code} - Configuration details',
    pageDescriptionFormat: '*{productName} {options} {accessories}',
    title: '*Your selected configuration',
    visualizationNotAvailableText: '*Visualization not available',
    configurationInvalidOrObsolete: 'Configuration is invalid or obsolete, please configure again before purchase.',
    unableToValidateConfigurationCode: 'There was a problem with validating configuration and purchase is disabled, please try again later or contact customer support.'
  },
  confirmationPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Ordrebekræftelse',
    title: 'Tillykke!',
    errorTitle: 'Der opstod en fejl',
    errorContent: 'Der opstod en fejl, kontakt support',
    paymentConfirmed: '*Your payment is confirmed, we hope you enjoyed shopping with us.',
    checkYourEmail: '*For order & delivery details check your e-mail address.',
    orderSection: {
      title: '*Your order',
      orderNumber: '*Order number',
    },
    summarySection: {
      title: '*Summary',
      taxText: '*+ VAT',
      totalToPayText: 'total',
      contact: {
        contactAndBilling: '*Contact & Billing',
        deliveryAddress: '*Delivery address',
      },
    },
    designerSectionTitle: '*Do you know who designed your chair?',
    customerStorySectionTitle: '*Do you know how to sit?',
    readMore: '*Read more',
    contactUsSection: {
      text: '*If you have any question contact with our',
      linkText: '*customer service',
    },
  },
  checkoutPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Til kassen',
    title: 'Checkout',
    goBackLink: 'Tilbage',
    progress: {
      title: 'Til kassen',
      deliveryStep: 'Levering',
      paymentStep: 'Betaling',
      confirmationStep: 'Bekræftelse',
    },
    goToPaymentButton: '*Confirm & pay with',
    paymentMethodLabel: '*How would you like to pay?',
    orderAndPayButton: 'Order and pay',
    submitButton: 'Send',
    paymentPoweredByText: '*We use a payment solution from',
    addressForm: {
      city: {
        name: 'By',
        placeholder: 'Angiv by',
        fieldRequired: 'By er obligatorisk',
      },
      country: {
        name: 'Land',
        placeholder: 'Angiv land',
        fieldRequired: 'Land er obligatorisk',
      },
      street: {
        name: 'Gadenavn',
        placeholder: 'Angiv gadenavn',
        fieldRequired: 'Gadenavn er obligatorisk',
      },
      streetNumber: {
        name: 'Husnummer',
        placeholder: 'Angiv husnummer',
        fieldRequired: 'Husnummer er obligatorisk',
      },
      zipCode: {
        name: 'Postnummer',
        fieldRequired: 'Postnummer er obligatorisk',
        wrongFormat: 'Den angivne værdi er ikke et gyldigt postnummer',
      },
      availableCountries: {
        POL: 'Polen',
        NOR: 'Norge',
        CHE: 'Schweiz',
        DEU: 'Tyskland',
        DNK: 'Danmark',
        FRA: 'Frankrig',
        NLD: 'Holland',
        SWE: 'Sverige',
        GBR: 'Storbritannien',
        USA: 'USA',
      },
      addressLine1: {
        name: 'Address Line 1',
        placeholder: '',
        fieldRequired: 'Address Line 1 is required',
        wrongFormat: '',
      },
      addressLine2: {
        name: 'Address Line 2',
        placeholder: '',
        fieldRequired: '',
        wrongFormat: '',
      },
      recipient: {
        name: 'Recipient',
        placeholder: '',
        fieldRequired: 'Recipient is required',
        wrongFormat: '',
      },
    },
    contactForm: {
      contactDetails: 'Kontaktoplysninger',
      email: {
        name: 'E-mail',
        placeholder: 'Angiv e-mail',
        fieldRequired: 'E-mail er obligatorisk',
        wrongFormat: 'Den angivne værdi er ikke en gyldig e-mailadresse',
      },
      phone: {
        name: 'Telefon',
        placeholder: 'Angiv telefon',
        fieldRequired: 'Telefon er obligatorisk',
        wrongFormat: '*Entered value is not a valid phone number',
      },
      phonePrefix: {
        name: '*Prefix',
        placeholder: '+ _ _',
        fieldRequired: '*Prefix is required',
        wrongFormat: '*Entered value is not a valid phone prefix',
      },
      firstName: {
        name: 'Fornavn',
        placeholder: 'Angiv fornavn',
        fieldRequired: 'Fornavn er obligatorisk',
      },
      lastName: {
        name: 'Efternavn',
        placeholder: 'Sidste efternavn',
        fieldRequired: 'Efternavn er obligatorisk',
      },
      companyName: {
        name: 'Company name (optional)',
        placeholder: '',
      },
      taxId: {
        name: 'Selskabsskat id',
        placeholder: '',
        fieldRequired: 'Virksomhedsskat id er påkrævet',
      },
    },
    shippingMethodSection: {
      subtitle: 'Delivery method',
      shippingMethod: {
        name: 'Shipping Method',
        fieldRequired: 'This field is required',
      },
    },
    deliveryAddressSection: {
      subtitle: 'Delivery address',
      billingAndDeliveryAreTheSameText: 'Billing & Delivery address are the same',
      deliveryInfoText: 'Free home delivery in 10-15 days',
    },
    paymentMethods: {
      supportedCreditCardsMessage: {
        acceptedCreditCardsText: '*We accept the following payment cards',
      },
      klarna: {
        selectPaymentCategory: `Please select payment category:`
      }
    },
    readyToOrderSection: {
      subtitle: 'Ready to order?',
      termsAndConditions: {
        termsAndConditionLinkName: 'Terms & Conditions',
        name: 'Jeg accepterer vilkårene',
        placeholder: '',
        fieldRequired: 'This field is required',
      },
      subscription: "I'd like to receive additional…",
    },
    readyToOrderPaymentSection: {
      subtitle: 'Klar til at bestille?',
    },
    errors: {
      creatingOrderFailed: 'Unable to place order. Please try again or contact customer support.',
      initializingPaymentFailed: 'Payment processing failed. Please try again or contact customer support.',
      authorizingPaymentFailed: 'Authorization failed. Please try again or contact customer support.',
      finalizingPaymentFailed: 'Payment processing failed. Please try again or contact customer support.',
    },
    discountCodeForm: {
      applyButton: '*Apply',
      discountCodeIsAppliedMessage: '*The "{code}" discount code is applied.',
      discountCodeIsInvalidOrExpiredError: '*The code you entered is invalid or has expired.',
      doYouHaveDiscountCodeText: '*Do you have a promotion or campaign code?',
      enterCodeText: '*Insert code here',
      label: '*Promo code',
    },
  },
  checkoutShortcutPage: {
    pageTitleFormat:
      'Checkout shortcut',
    pageDescriptionFormat:
      '',
    errors: {
      addingProductToCartFailed:
        'Unable to purchase product configuration with code {code}. Please contact customer support.',
      gettingProductConfigurationFailed:
        'Unable to retrieve information about product configuration with the code {code}. Please refresh page or contact customer support.',
    }
  },
  configurationPage: {
    pageDescriptionFormat: '{productName} {options} {accessories}',
    pageTitleFormat: '{productName} - Konfigurator',
    productDetails: {
      documentsSection: 'Dokumenter',
      moreInformationSection: 'Flere oplysninger',
      specificationSection: 'Specifikation',
    },
    showFiltersText: '*Show filters',
    hideFiltersText: '*Hide filters',
    productModels: {
      chooseModelText: '*Choose your model',
      modelSelectorWithLoader: {
        noOtherModelsAvailable: '*There are no other models available.',
      },
    },
    options: {
      title: 'Tilpas din stol',
      priceGroup: 'Prisgruppe',
      textSelected: 'Valgt',
      fabricFilters: {
        noFabricsAvailable: 'Der er intet stof, der matcher dine præferencer.',
        clearButton: 'Ryd',
        defaultFilterName: 'Alle',
        collectionFilterLabel: '*Collection'
      },
    },
    accessories: {
      title: 'Tilbehør',
      accessory: {
        removeButton: 'Fjern',
        addButton: 'Tilføj',
        textSelected: 'Valgt',
      },
    },
    summary: {
      title: 'Din ordreoversigt',
      accessoriesSubtitle: 'Tilbehør',
      requestQuoteButton: 'Anmod om et tilbud',
      emailConfirmationButton: 'Send min konfiguration via e-mail',
      checkoutButton: 'Til kassen',
      editConfigurationLink: 'Rediger',
      limitedChairQuantity: '*To order more than {max} chairs please contact us',
      expectedShipment: {
        expectedShipment: '*Ready for shipping within',
        days: '*working days',
      },
      quantityInput: {
        outOfRangeWarning: 'Værdien skal være mellem {min} og {max}',
      },
      saveYourConfigurationHereButton: '*Save your configuration here.',
      backButton: '*Back',
      shareSection: {
        title: 'Gem din konfiguration',
        yourConfigurationUrl: 'Din konfigurations-URL',
        downloadAsPdf: 'Download som PDF',
        downloadVisualizations: 'Download visualiseringer',
        codeShare: {
          codeTitle: 'Din konfigurationskode',
          copyCode: {
            label: 'Kopier kode',
            textCopiedLabel: 'Kopieret',
          },
        },
        copyLink: {
          label: 'Kopier link',
          textCopiedLabel: 'Kopieret',
        },
        closeButton: 'Luk',
      },
      findLocalDealerSection: {
        title: 'Hvor finder jeg Flokk?',
        button: 'Find lokal forhandler',
      },
    },
    restrictions: {
      accessorySelection: {
        header: {
          userSelectionNotRequiredFormat: 'Er du sikker på, at du vil tilføje tilbehøret {itemName}?',
          userSelectionRequiredFormat: 'Hvis du vil tilføje {itemName}, skal du ændre præferencer',
        },
        automaticDeselectionOfAccessoriesFormat:
          'Det valgte tilbehør er ikke tilgængeligt med {itemsToDeselect}. Hvis du vælger dette tilbehør, vil tilhøret nedenfor blive fjernet fra din ordre.',
      },
      optionSelection: {
        header: {
          userSelectionNotRequiredFormat: `Er du sikker på, at du vil ændre alternativet {itemName}?`,
          userSelectionRequiredFormat: `Hvis du vil ændre {itemName}, skal du ændre præferencer`,
        },
        automaticDeselectionOfAccessoriesFormat:
          'Det valgte alternativ er ikke tilgængeligt med {itemsToDeselect}. Hvis du vælger dette alternativ, vil tilbehøret nedenfor blive fjernet fra din ordre.',
      },
      itemNotAvailableWithFormat: '{itemToSelect} er ikke tilgængelig med {itemsToDeselect}.',
      itemsSeparator: ' og ',
      selectMatchingOption: ' Nedenfor kan du finde valgmuligheder, der matcher.',
      cancelButton: 'Annuller',
      applyButton: 'Acceptér, skift',
      closeButton: 'Luk',
      selectedText: 'Valgt',
    },
    tabs: {
      fabrics: {
        name: 'Stof',
      },
      options: {
        name: 'Indstillinger',
      },
      accessories: {
        name: 'Tilbehør',
      },
      summary: {
        name: 'Oversigt',
      },
    },
    productNotAvailableInCurrentStoreWarning: {
      messageFormat:
        '*This product is not available in your country ({currentStore}). If you like it please contact customer support.',
    },
    productInactiveWarning: {
      discontinued: '*This is a discontinued product',
      generic: '*Product is not available',
      genericWithReason: '*Product is not available: {reason}'
    },
    obsoleteCodeModal: {
      notAvailable: {
        title: '*Chair configuration is not available',
        intro: 'Given product configuration is not available.',
        introWithCodePart1: 'Given product configuration with the code',
        introWithCodePart2: 'is not available.',
        explanation: "The following parts or materials can't be used anymore:",
      },
      restricted: {
        title: '*Chair configuration is not valid',
        intro: 'Given product configuration is not valid.',
        introWithCodePart1: 'Given product configuration with the code',
        introWithCodePart2: 'is not valid.',
        explanation: 'This might be caused by changes in the product set up.',
      },
      footer: 'Please configure your chair once again.',
      closeButton: 'Close',
    },
    optionDescriptionModal,
    metaTitleFormat: 'Min {productName}',
    metaDescriptionFormat: '{productName}: {options}',
    priceTaxText: 'inkl. skat',
  },
  modularConfiguratorPage: {
    pageDescriptionFormat: '{productName} {options} {accessories}',
    pageTitleFormat: '{productName} - Konfigurator',
  },
  storeAndLanguageSelector: {
    title: 'Vælg dit land eller sprog',
    storeSelectorLabel: 'Land',
    languageSelectorLabel: 'Sprog',
  },
  initialStoreSelectorModal: {
    title: '*Hi there',
    description: '*Find your country or go to our international page',
    buttonContinue: '*Continue',
    inputPlaceholder: '*Select your country',
    languageInputPlaceholder: '*Select language',
    linkLabelInternationalStore: '*Go to international page',
    noOptionMessage: '*This country is not found',
    noLanguageMessage: '*This language is not found',
  },
  noConnectionModal: {
    title: 'Ups! ',
    content: 'Der blev ikke fundet en internetforbindelse.',
    continueLink: 'Fortsæt',
    buttonSeparator: 'eller',
    refreshButton: 'Opdater side',
    closeButton: 'Luk',
  },
  emptyCartPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Tøm kurven',
    basketEmptyLine1: 'Din kurv er tom',
    basketEmptyLine2: 'men det behøver den ikke at være.',
    continueButton: 'Shop videre',
  },
  pageNotFound: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Siden blev ikke fundet',
    content: 'Side  Vi kan tilsyneladende ikke finde den side, du leder efter.',
    title: 'Åh nej!',
    buttonLink: 'Gå til startsiden',
  },
  generalErrorPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Generel fejl',
    title: 'Intern serverfejl!',
    content: 'Prøv igen senere',
    buttonLink: 'Prøv igen',
  },
  invalidCodePage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Ugyldig kodeside',
    title: 'Ugyldig konfigurationskode',
    content: 'Angiv en gyldig',
    buttonLink: 'Tilbage til Flokk',
  },
  productSpecificationPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Produktspecifikation',
    accessoriesSection: 'Tilbehør',
    linkTitle: 'Dit konfigurationslink',
    codeTitle: 'Din konfigurationskode',
    pricesSection: {
      unitPrice: 'Pris pr. enhed',
      quantity: 'Antal',
      subtotalPrice: 'Subtotal',
    },
    dataSection: {
      title: 'Data',
      brand: 'Brand',
      code: 'Vare.-nr.',
    },
  },
  storeLocatorPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Find butikker, showroom og Flokk-kontorer',
    heading: 'Find din butik',
    storeSearch: {
      noDealersText: 'Vi har desværre ingen butikker eller kontorer i dette område.',
      noDealersWithFiltersText: 'Vi har desværre ingen butikker eller kontorer, som matcher de aktive filtre. ',
      filterResultText: '{storesNumber} placering fundet',
      storeLocatorInput: {
        label: 'Find din butik',
        placeholder: 'By eller postnummer',
        orText: 'eller',
        currentLocationText: 'brug aktuel placering',
        disabledGeolocationText: 'Geoplacering er deaktiveret.',
        unavailableGeolocationText: 'Geoplacering er ikke tilgængelig.',
        tryAgainText: 'Prøv igen.',
      },
      storeLocatorFilters: {
        title: 'Filtre',
        placesLabel: 'Type af steder',
        brandLabel: 'Brand',
      },
    },
    storeTypes: {
      Showroom: 'Showroom',
      Shop: 'Butik',
    },
    details: {
      webSite: 'Website',
      address: 'Adresse',
      directionLink: 'Kørselsanvisninger',
      email: 'E-mail',
      openHours: 'Åbningstider',
      phone: 'Telefon',
      closeButton: 'Luk',
      backButton: 'Tilbage til listen',
    },
  },
  cart: {
    summary: {
      deliveryFee: 'Leveringsgebyr',
      subTotal: '*Price before VAT',
      totalTaxFormat: '*Vat ({taxTotal}%)',
      subTotalWithTax: '*Total price including VAT',
      totalToPay: 'I alt til betaling',
      moreInformationText: 'More information',
      lessInformationText: 'Less information',
      quantityText: 'Qty',
      shippingTimeText: {
        deliveredWithin: '*Delivered within',
        day: '*day',
        days: '*days',
        week: '*week',
        weeks: '*weeks',
      },
      configurationCodeLabel: 'ID',
      deliveryCostUnavailable: 'Select shipping method',
      freeDeliveryText: 'Free home delivery',
      taxText: '+ VAT',
      discount: '*Discount',
      surcharges: {
        'eco-tax': '*Eco tax'
      },
    },
  },
  redirectionWarningModal: {
    closeButton: 'Luk',
    title: "You'll be automatically redirected in a few seconds. Interact with the screen to cancel redirection.",
  },
  scrollToTop: {
    button: '*Go to top',
  },
  productFamilyPage: {
    pageDescriptionFormat: 'beskrivelse',
    pageTitleFormat: 'Produktside',
    overviewSection: {
      name: 'Oversigt',
    },
    relatedProducts: {
      name: 'Relaterede produkter',
      title: 'Du vil måske også syntes om',
    },
    designerSection: {
      name: 'Designer',
      designedBy: 'Designet af',
      readMore: 'Læs mere',
    },
    productUserStories: {
      name: '*Projects',
      readMore: 'Læs mere',
      title: ' *Project',
    },
    modelsSection: {
      name: 'Modeller',
      productInfo: {
        priceSection: {
          taxText: 'inkl. skat',
          fromText: 'fra',
        },
        popularDesigns: {
          title: 'Populære designs',
        },
        actions: {
          configureChairButton: 'Design din egen stol',
          askForPriceButton: 'Anmod om pris',
          goToCheckoutButton: '*Add to cart',
          whereToBuyButton: '*Where to buy',
        },
        whereToBuy: {
          text: '*We sell our products through a network of authorized partners.',
          designCustomChairText:
            '*However, if you’d like to create a bespoke chair please design your own above and we’ll come back to you with a price.',
        },
      },
      productModelSelector: {
        heading: '*Choose your variant',
      },
      modelViewer: {
        hint: 'Klik på billedet for at åbne zoom-tilstand',
      },
    },
    productModelDetailsSection: {
      assetsDownloader: {
        downloadAllButton: '*Download all',
        other: '*Other',
        categories: {},
      },
      downloadsSectionTitle: '*Downloads',
      environmentalDataSection: {
        averagedValuesDisclaimerText:
          '*All values are average for this model, for some products the numbers might differ.',
        energyUsageMjText: '*Energy usage',
        co2EmissionKgText: '*Carbon dioxide emission',
        recyclableMaterialsText: '*recyclable materials',
        recycledAluminiumText: '*recycled aluminium',
        recycledMaterialsTitle: '*Ratio of recycled materials',
        recycledMaterialsText: '*recycled materials',
        recycledPlasticText: '*recycled plastic',
        recyclableMaterialsTitle: '*Recycling rate',
      },
      environmentalDataSectionTitle: '*Environmental data',
      name: '*Details',
      specificationSectionTitle: '*Specification',
    },
    suggestedConfigurationsSection: {
      name: 'Variationer',
      title: 'Leder du efter noget specielt?',
      subtitle: 'Vælg mellem muligheder som farve, stof, materialer, tilbehør og meget mere.',
      buttonText: 'Design din egen Capisco',
    },
    gallerySection: {
      name: 'Galleri',
    },
    userGuideVideoSection: {
      name: '',
      videoTitle: '*Userdemo',
    },
  },
  viewerPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Fremviser',
  },
  zoomModal: {
    closeButton: 'Luk',
  },
  common: {
    chairVisualization: {
      zoomHintText: 'Tryk for at zoome ind/ud',
      hintText: 'Klik på billedet for at åbne zoomtilstand',
      renderingError: '*Sorry, we are not able to load visualisation for this configuration.',
      webGLUnsupportedError:
        '*Sorry, we are not able to load visualisation, because WebGL is not supported in your browser.',
    },
    tags: {
      clearResults: '*Remove all',
    },
  },
  catalogPage: {
    pageTitleFormat: '*Products',
    pageDescriptionFormat: '*Find your chair ',
    filterBar: {
      name: 'Filters',
      results: '*All results: {results}',
    },
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Værdien skal bestå af nøjagtigt {expectedLength} tegn.',
      codeInvalid: 'Den oplyste kode {invalidCode} er ugyldig! Sørg for, at den er angivet korrekt.',
      codeNotFound: 'Produktkonfigurationen kan ikke findes med koden {notFoundCode}',
    },
    productFamily: {
      showMoreProducts: '*More options available',
    },
    searchForConfigurationText: '*Already made a design? Find your configuration',
    noResults: '*There are no products matching your preferences.',
    pagination: {
      title: '*Pagination',
    },
  },
  disclaimer: {
    messagePart1: '*The appearance of the color depends on your device or screen setup. ',
    link: '*Contact us',
    messagePart2: ' *if you need help choosing the right colour and/or texture.',
  },
  requestQuoteLink: {
    link: '*Buying for a company? Request a quote here.',
  },
  unauthorizedErrorPage: {
    pageDescriptionFormat: '*Description',
    pageTitleFormat: '*Unauthorized',
    title: '*Unauthorized',
    content: '*Access is allowed only for registered users.',
    buttonLink: '*Login',
  },
  forbiddenErrorPage: {
    pageDescriptionFormat:
      '*You do not have necessary permissions to access this page.',
    pageTitleFormat:
      '*Forbidden',
    title:
      '*Oh, no!',
    content1:
      '*You do not have the necessary permissions to access this page. You can ',
    logout:
      'log out',
    content2:
      ' and try another account or contact Flokk support.',
    buttonLink:
      '*Take me home'
  },
  downloadsPage: {
    downloadList: {
      download: {
        downloadButton: '*Download',
      },
      emptyScreen: {
        title: '*There are no files matching your criteria.',
        description: '*Sorry, we don’t seem to have what you are looking for. Please try different filters.',
      },
      results: '*There are {results} files matching you criteria.',
      pagination: {
        title: '*Pagination',
      },
    },
    filters: {
      title: '*Filters',
      brandsFilter: {
        name: '*Popular brands',
      },
      categoryFilter: {
        name: '*Category',
        fileTypeFilter: {
          name: '*File type',
        },
        resultsCounter: '*All results',
      },
      downloadAllButton: '*Download all',
    },
    pageTitleFormat: '*Downloads',
    pageDescriptionFormat: '*Find and download product resources, such as fact sheets, images, CADs etc.',
  },
  readyMadeProductPage: {
    overviewSection: {
      name: '*Overview',
    },
    variationsSection: {
      name: '*Variations',
    },
    specificationSection: {
      name: '*Specification',
    },
    productDetailsSection: {
      specificationSectionTitle: '*Specification',
      maintenanceSectionTitle: '*Maintenance',
      downloadsSectionTitle: '*Downloads',
      assetsDownloader: {
        downloadAllButton: '*Download all',
        other: '*Other',
        categories: {},
      },
      productCare: {
        downloadGuide: '*Download guide here',
      },
    },
    productVariations: {
      addToCartButton: '*Add to cart',
      buyButton: '*Buy',
      deliveryTime: {
        deliveryTime: '*Delivery time',
        day: '*day',
        days: '*days*',
        week: '*week',
        weeks: '*weeks*',
      },
      priceIncludingTax: '*Incl. Tax, plus shipping cost',
      deliveryTimeAnnotation: '** Delivery time may be longer for some configurations',
      modelViewer: {
        hint: 'Klik på billedet for at åbne zoom-tilstand',
      },
      customizationSection: {
        textLine1: '*Looking for something different?',
        textLine2: '*You can',
        linkText: '*customise your choice here',
      },
      productOptions: {
        fabricInfo: {
          text: '*Fabric information:',
          optionDescriptionModal,
        },
        fabricDescriptionCannotBeLoadedError:
          '*Sorry, something went wrong. Cannot load the information about the fabric.',
      },
    },
    productCarousel: {
      title: '*Others have also looked at these chairs',
    },
  },
};

export default translation;
